import React, { FunctionComponent } from 'react';
import styles from '../../../../styles/ArticleContent.module.scss';

type Props = {
    content: string;
};

const removeWrapper = (content: string) => {
    return content.replace(/(<\/?(ul|ol)>)/g, '');
};

export const List: FunctionComponent<Props> = ({ content }) => {
    content = removeWrapper(content);

    return <ul className={`${styles.listBlock}`} dangerouslySetInnerHTML={{ __html: content }}></ul>;
};
